import * as THREE from "three";

export class ObjectHighlighter {
    constructor(scene, options = {}) {
        this.scene = scene;

        this.tintColor = new THREE.Color(options.color ?? 0x4da3ff);
        this.tintStrength = options.tintStrength ?? 0.35;
        this.auraScale = options.auraScale ?? 1.06;
        this.auraOpacity = options.auraOpacity ?? 0.25;

        this.originalMaterials = new Map();

        // references
        this.target = null;
        this.aura = null;

        // reusable helpers (IMPORTANT)
        this.box = new THREE.Box3();
        this.size = new THREE.Vector3();
        this.center = new THREE.Vector3();

        this.auraMaterial = new THREE.MeshBasicMaterial({
            color: this.tintColor,
            transparent: true,
            opacity: this.auraOpacity,
            side: THREE.BackSide,
            depthWrite: false
        });
    }

    clear() {
        // restore original materials
        this.originalMaterials.forEach((material, mesh) => {
            mesh.material = material;
        });
        this.originalMaterials.clear();

        this.target = null;

        // remove aura
        if (this.aura) {
            this.scene.remove(this.aura);
            this.aura.geometry.dispose();
            this.aura = null;
        }
    }

    highlightObject(object) {
        this.clear();
        this.target = object;

        // 1️⃣ TINT CAŁEGO OBIEKTU
        object.traverse((child) => {
            if (!child.isMesh) return;

            this.originalMaterials.set(child, child.material);

            const mat = child.material.clone();
            mat.color.lerp(this.tintColor, this.tintStrength);
            child.material = mat;
        });

        // 2️⃣ AURA (unit cube → skalowana dynamicznie)
        const geometry = new THREE.BoxGeometry(1, 1, 1);
        this.aura = new THREE.Mesh(geometry, this.auraMaterial);
        this.scene.add(this.aura);

        this.update(); // initial sync
    }

    update() {
        if (!this.target || !this.aura) return;

        this.box.setFromObject(this.target);
        this.box.getSize(this.size);
        this.box.getCenter(this.center);

        this.aura.position.copy(this.center);

        this.aura.scale.set(
            this.size.x,
            this.size.y,
            this.size.z
        ).multiplyScalar(this.auraScale);
    }

    setColor(color) {
        this.tintColor.set(color);
        this.auraMaterial.color.set(color);
    }
}
